import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { runWhenDomLoaded } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'submitButton',
    'deleteButton',
    'editButton',
    'flagButton',
    'bodyContainer',
    'expandBodyButton',
  ];

  static values = { authorId: Number };

  connect() {
    if (
      CurrentUser.id() == this.authorIdValue ||
      CurrentUser.isAuthor() ||
      CurrentUser.isAdmin()
    ) {
      if (this.hasDeleteButtonTarget) this.deleteButtonTarget.hidden = false;
    }

    if (CurrentUser.id() == this.authorIdValue) {
      if (this.hasEditButtonTarget) this.editButtonTarget.hidden = false;
    }

    if (CurrentUser.isAuthor() || CurrentUser.isAdmin()) {
      if (this.hasFlagButtonTarget) this.flagButtonTarget.hidden = false;
    }

    if (this.hasBodyContainerTarget) {
      // NB: If the element is not fully rendered initally (because it is collapsed in a thread) we need to recalculate
      // the required height vs.the visible content (limited by line-clamp)
      this.element.addEventListener(
        'comments--comment--component:update-read-more-button-visibility',
        this.handleUpdateReadMoreVisibilityEvent.bind(this)
      );

      // NB: We have to wait for the CSS being parsed and applied before the body clamping effect can be calculuated
      runWhenDomLoaded(this.updateReadMoreButtonVisibility.bind(this));

      this.updateReadMoreButtonVisibility();
    }
  }

  handleUpdateReadMoreVisibilityEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    this.updateReadMoreButtonVisibility();
  }

  updateReadMoreButtonVisibility() {
    const bodyIsClamped =
      this.bodyContainerTarget.scrollHeight >
      this.bodyContainerTarget.clientHeight;
    this.expandBodyButtonTarget.hidden = !bodyIsClamped;
  }

  disableSubmit() {
    this.submitButtonTarget.disabled = true;
  }

  enableSubmit() {
    this.submitButtonTarget.disabled = false;
  }

  expandBody() {
    this.expandBodyButtonTarget.hidden = true;
    this.bodyContainerTarget.classList.add('is-expanded');
  }
}

export function updateReadMoreButtonVisibility(commentElement) {
  commentElement.dispatchEvent(
    new CustomEvent(
      'comments--comment--component:update-read-more-button-visibility'
    )
  );
}
